/** 
 * Processes front-end form for editing an individual Location
 * Ref. Dealer Profile page
 */

class LocationEdit {
  constructor() {
    this.links = document.querySelectorAll('.dealer__locations--link');
    this.formholder = document.querySelector('.dealer__locations--form');

    if (this.links.length < 1) {
      return false;
    }
    this.events();
  }

  events() {
    [...this.links].forEach((link, i) => {
      link.addEventListener('click', this.addForm.bind(this));
      if(i === 0) {
        link.click();
      }
    });

    this.formholder.addEventListener('submit', this.saveForm.bind(this));
  }

  /**
   * The target tag's dataset contains the location id for the dealer
   * Adds the form to the page DOM
   * @param Event e 
   * @returns void
   */
  addForm(e) {
    e.preventDefault();
    const id = e.target.dataset.loc;
    const url = '/location-edit/form/' + id;
    return Promise.all([
      this.getForm(url)
    ])
    .then ( form => {
      this.formholder.innerHTML = form;
      tinymce.init({
        selector: "textarea[data-editor='tinyMCE']",
        skin: 'silverstripe',
        max_height: 250,
        menubar: false
      }); 
    });
  }

  /**
   * Fetches html for a populated edit form from the server,
   * and passes back to the addForm method
   * @param String url 
   * @returns Promise form html
   */
  getForm(url) {
    return fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type':'text/html'
      }
    })
    .then(response => response.text())
  }

  /**
   * Saves the form data via ajax 
   * Removes the form from the DOM
   * @param Event e
   * @returns void
   */
  saveForm(e) {
    e.preventDefault();
    const url = '/location-edit/save';
    const form = e.target;

    if(!form.reportValidity()) {
      return;
    }
    const data = new FormData(form);
    // For controller function - identify request as ajax
    data.append('ajax', true);

    return fetch(url, {
      method: 'POST',
      body: data
    })
    .then(response => response.text())
    .then(data => {
      if(data == 'Success') {
        alert('Your changes have been saved');
      } else {
        alert('Something went wrong. Nothing was saved.')
      }
    })
  }


}

export default LocationEdit;
